import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { connectorsApi } from '@/api/connectors'
import { useTenantKey } from './useTenantKey'
import type { SaveSonarQubeConnectionRequest, TestSonarQubeConnectionRequest } from '@/types'

export function useSonarQubeConnection(projectId: string) {
  const tenantKey = useTenantKey()
  return useQuery({
    queryKey: tenantKey('projects', projectId, 'sonarqube-connection'),
    queryFn: () => connectorsApi.getSonarQubeConnection(projectId),
    enabled: !!projectId,
  })
}

export function useCreateSonarQubeConnection(projectId: string) {
  const queryClient = useQueryClient()
  const tenantKey = useTenantKey()
  return useMutation({
    mutationFn: (data: SaveSonarQubeConnectionRequest) => connectorsApi.createSonarQubeConnection(projectId, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: tenantKey('projects', projectId, 'sonarqube-connection') }),
  })
}

export function useUpdateSonarQubeConnection(projectId: string) {
  const queryClient = useQueryClient()
  const tenantKey = useTenantKey()
  return useMutation({
    mutationFn: (data: SaveSonarQubeConnectionRequest) => connectorsApi.updateSonarQubeConnection(projectId, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: tenantKey('projects', projectId, 'sonarqube-connection') }),
  })
}

export function useDisableSonarQubeConnection(projectId: string) {
  const queryClient = useQueryClient()
  const tenantKey = useTenantKey()
  return useMutation({
    mutationFn: () => connectorsApi.disableSonarQubeConnection(projectId),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: tenantKey('projects', projectId, 'sonarqube-connection') }),
  })
}

export function useTestSonarQubeConnection(projectId: string) {
  return useMutation({
    mutationFn: (data: TestSonarQubeConnectionRequest) => connectorsApi.testSonarQubeConnection(projectId, data),
  })
}
